import React from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import Moment from "moment";
import "moment/locale/id";
import { getListKategoriJson } from "stores/Pengajuan/function";

function Step1() {
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const valDetail = pengajuan.detailPengajuan || {};
  console.log(valDetail, " VAL DETAIL");
  const dispatch = useDispatch();

  Moment.locale("id");

  const formatDate = (date) => {
    if (!date) return null;
    const momentDate = Moment(date);
    return momentDate.isValid() ? momentDate.format("DD MMMM YYYY") : date;
  };

  const tglLahir = formatDate(valDetail.tglLahir);
  const tglkeluarIdentitas = formatDate(valDetail.tglKeluarIdentitas);
  const tglBerlakuSampai = formatDate(valDetail.masaBerlakuIdentitas);
  const tglAkad = formatDate(valDetail.tglAkad);
  const tglAgenda = formatDate(valDetail.tglAgenda);

  React.useEffect(() => {
    getListKategoriJson(dispatch);
  }, [dispatch]);

  const sections = [
    {
      title: "Relasi & Sistem",
      fields: [
        { label: "Client", value: valDetail?.client?.namaClient },
        { label: "Cabang", value: valDetail?.cabang?.namaCabang },
        {
          label: "Koordinator Wilayah",
          value:
            valDetail?.korwil?.nama ||
            valDetail?.korwil?.nama ||
            valDetail?.idKorwil,
        },
        {
          label: "Area Manager",
          value:
            valDetail?.areaManager?.nama ||
            valDetail?.areaManager?.nama ||
            valDetail?.idAreaManager,
        },
        {
          label: "Supervisor",
          value:
            valDetail?.supervisor?.nama ||
            valDetail?.supervisor?.nama ||
            valDetail?.idSupervisor,
        },
        {
          label: "Marketing",
          value:
            valDetail?.marketing?.nama ||
            valDetail?.marketing?.nama ||
            valDetail?.idMarketing,
        },
        { label: "Wilayah", value: valDetail?.wilayah?.namaWilayah },
        { label: "Reference ID", value: valDetail?.id_pinjaman },

        { label: "Note Reject", value: valDetail?.note_reject },
        { label: "Alasan Penolakan", value: valDetail?.alasanPenolakan },
        { label: "Action", value: valDetail?.action },
        { label: "Regis Number", value: valDetail?.regisNumber },
      ],
    },
    {
      title: "Data Pribadi",
      fields: [
        { label: "Nama Lengkap", value: valDetail?.namaLengkap },
        { label: "Nama Panggilan", value: valDetail?.namaPanggilan },
        {
          label: "Jenis Kelamin",
          value:
            valDetail?.jenisKelamin === "L"
              ? "Laki-Laki"
              : valDetail?.jenisKelamin === "P"
                ? "Perempuan"
                : valDetail?.jenisKelamin,
        },
        {
          label: "Agama",
          value:
            {
              1: "Budha",
              2: "Hindu",
              3: "Islam",
              4: "Katolik",
              5: "Kristen Protestan",
              7: "Konghucu",
            }[valDetail?.agama] || valDetail?.agama,
        },
        { label: "Tempat Lahir", value: valDetail?.tempatLahir },
        { label: "Tanggal Lahir", value: tglLahir },
        {
          label: "Status Menikah",
          value:
            valDetail?.statusMenikah === "KAWIN"
              ? "Menikah"
              : valDetail?.statusMenikah === "BELUM"
                ? "Lajang"
                : valDetail?.statusMenikah === "CERAI"
                  ? "Cerai"
                  : valDetail?.statusMenikah,
        },
        { label: "Nomor Handphone", value: valDetail?.noHp },
        { label: "Email", value: valDetail?.email },
        {
          label: "Pendidikan",
          value:
            {
              "01": "SEKOLAH DASAR (SD)",
              "02": "SMP / SLTP",
              "03": "SMA / SLTA",
              "04": "DIPLOMA III (D3)/AKADEMI",
              "05": "UNIVERSITAS / S-1",
              "06": "UNIVERSITAS / S-2",
              "07": "UNIVERSITAS / S-3",
            }[valDetail?.pendidikan] || valDetail?.pendidikan,
        },
        { label: "Gelar", value: valDetail?.gelar },
        {
          label: "SID Gelar",
          value:
            {
              "0100": "TANPA GELAR",
              "0101": "DIPLOMA 1",
              "0102": "DIPLOMA 2",
              "0103": "DIPLOMA 3",
              "0104": "STRATA 1",
              "0105": "STRATA 2",
              "0106": "STRATA 3",
            }[valDetail?.sidGelar] || valDetail?.sidGelar,
        },
        { label: "Nama Ibu Kandung", value: valDetail?.namaIbuKandung },
        {
          label: "Biaya Hidup",
          value: valDetail?.biayaHidup
            ? `Rp ${Number(valDetail.biayaHidup).toLocaleString("id-ID")}`
            : null,
        },
        {
          label: "Tipe Nasabah",
          value:
            valDetail?.tipeNasabah === "001"
              ? "Individual"
              : valDetail?.tipeNasabah,
        },
        { label: "Citizen", value: valDetail?.citizen },
        { label: "Child Dependent", value: valDetail?.childDependent },
        { label: "Other Dependent", value: valDetail?.otherDependent },
      ],
    },
    {
      title: "Identitas & Alamat KTP",
      fields: [
        {
          label: "Jenis Identitas",
          value:
            valDetail?.jenisIdentitas === "KTP"
              ? "KTP"
              : valDetail?.jenisIdentitas === "SIM"
                ? "SIM"
                : valDetail?.jenisIdentitas,
        },
        { label: "Nomor Identitas", value: valDetail?.nomorIdentitas },
        { label: "NPWP", value: valDetail?.npwp },
        {
          label: "Tempat Dikeluarkan Identitas",
          value: valDetail?.tempatDikeluarkanIdentitas,
        },
        {
          label: "Tanggal Keluar Identitas",
          value: tglkeluarIdentitas,
        },
        { label: "Identitas Berlaku Sampai", value: tglBerlakuSampai },
        { label: "Alamat KTP", value: valDetail?.alamatKtp },
        { label: "RT KTP", value: valDetail?.rt },
        { label: "RW KTP", value: valDetail?.rw },
        { label: "Kelurahan KTP", value: valDetail?.kelurahan },
        { label: "Kode Pos KTP", value: valDetail?.kodepos },
        { label: "Province", value: valDetail?.province },
        { label: "Current City", value: valDetail?.currentCity },
        { label: "Subdistrict", value: valDetail?.subdistrict },
      ],
    },
    {
      title: "Alamat Domisili",
      fields: [
        {
          label: "Domisili Sesuai KTP",
          value:
            valDetail?.domisiliSesuaiKtp === "true" ||
            valDetail?.domisiliSesuaiKtp === true
              ? "Ya"
              : valDetail?.domisiliSesuaiKtp === "false" ||
                  valDetail?.domisiliSesuaiKtp === false
                ? "Tidak"
                : valDetail?.domisiliSesuaiKtp,
        },
        { label: "Alamat Domisili", value: valDetail?.alamatDomisili },
        { label: "RT Domisili", value: valDetail?.rtDomisili },
        { label: "RW Domisili", value: valDetail?.rwDomisili },
        { label: "Kelurahan Domisili", value: valDetail?.kelurahanDomisili },
        { label: "Kode Pos Domisili", value: valDetail?.kodeposDomisili },
        { label: "Status Of Residence", value: valDetail?.statusOfResidence },
      ],
    },
    {
      title: "Ahli Waris",
      fields: [
        { label: "Nama Waris", value: valDetail?.namaWaris },
        { label: "Hubungan Waris", value: valDetail?.hubunganWaris },
        { label: "Alamat Waris", value: valDetail?.alamatWaris },
        {
          label: "Other Family Telephone",
          value: valDetail?.otherFamilyTelephone,
        },
      ],
    },
    {
      title: "Pencairan",
      fields: [
        {
          label: "Nominal Pencairan",
          value: valDetail?.nominalPencairan
            ? `Rp ${Number(valDetail.nominalPencairan).toLocaleString("id-ID")}`
            : null,
        },
        { label: "No Akad", value: valDetail?.noAkad },
        { label: "No Agenda", value: valDetail?.noAgenda },
        { label: "Tanggal Akad", value: tglAkad },
        { label: "Tanggal Agenda", value: tglAgenda },
        {
          label: "Cabang Pencairan",
          value:
            valDetail?.lokasiPencairan?.namaCabang ||
            valDetail?.idCabangPencairan,
        },
      ],
    },
  ];

  return (
    <div className="mt-4">
      <div
        className="d-flex align-items-center mb-4"
        style={{ borderBottom: "2px solid #f0f0f0", paddingBottom: "12px" }}
      >
        <h4
          style={{
            fontWeight: "800",
            textTransform: "uppercase",
            color: "#2C3E50",
            fontSize: "20px",
            margin: 0,
          }}
        >
          Informasi Nasabah
        </h4>
      </div>

      <div
        style={{
          maxHeight: "650px",
          overflowY: "auto",
          overflowX: "hidden",
          paddingRight: "10px",
          paddingBottom: "20px",
        }}
      >
        {sections.map((section, sIndex) => (
          <div key={sIndex} className="mb-5">
            <h5
              style={{
                fontWeight: "700",
                color: "#0284c7",
                fontSize: "16px",
                marginBottom: "16px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <span
                style={{
                  width: "8px",
                  height: "24px",
                  backgroundColor: "#0ea5e9",
                  borderRadius: "4px",
                  display: "inline-block",
                }}
              ></span>
              {section.title}
            </h5>
            <Row>
              {section.fields.map((item, index) => (
                <Col xs={12} sm={6} lg={4} key={index} className="mb-3">
                  <div
                    style={{
                      padding: "16px 20px",
                      backgroundColor: "#F8FAFC",
                      borderRadius: "14px",
                      height: "100%",
                      border: "1px solid #E2E8F0",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#F0F9FF";
                      e.currentTarget.style.boxShadow =
                        "0 6px 16px rgba(14, 165, 233, 0.12)";
                      e.currentTarget.style.transform = "translateY(-3px)";
                      e.currentTarget.style.borderColor = "#BAE6FD";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#F8FAFC";
                      e.currentTarget.style.boxShadow = "none";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.borderColor = "#E2E8F0";
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "700",
                        color: "#64748B",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        marginBottom: "6px",
                      }}
                    >
                      {item.label}
                    </div>
                    <div
                      style={{
                        fontSize: "15px",
                        color: "#1E293B",
                        fontWeight: "600",
                        textTransform:
                          item.label === "Email" ? "none" : "capitalize",
                        wordBreak: "break-word",
                        lineHeight: "1.4",
                      }}
                    >
                      {item.value !== null &&
                      item.value !== undefined &&
                      item.value !== "" ? (
                        item.value
                      ) : (
                        <span style={{ color: "#CBD5E1" }}>-</span>
                      )}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        ))}
      </div>
    </div>
  );
}
export default Step1;
